import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
export class NotaVentaDetallesComponent {
    constructor(gqlclient, accesolocalstorage, fb, clog, formatoProductoService, productoService, saldoStockService, notaVentaService, toastService, messageRendererService, documentoService, documentoNoTributarioService, formValidatorsService) {
        this.gqlclient = gqlclient;
        this.accesolocalstorage = accesolocalstorage;
        this.fb = fb;
        this.clog = clog;
        this.formatoProductoService = formatoProductoService;
        this.productoService = productoService;
        this.saldoStockService = saldoStockService;
        this.notaVentaService = notaVentaService;
        this.toastService = toastService;
        this.messageRendererService = messageRendererService;
        this.documentoService = documentoService;
        this.documentoNoTributarioService = documentoNoTributarioService;
        this.formValidatorsService = formValidatorsService;
        this.permiteUnidadNegocio = false;
        this.onEditingProduct = new EventEmitter();
        this.onAddProductoRequest = new EventEmitter();
        this.onDeleteProductoRequest = new EventEmitter();
        this.headerData = null; // Viene desde Cabecera
        this.productoSeleccionado = null;
        this.optionsFormato = [];
        this.currentProcess = null;
        this.totalesDocumento = null;
        this.inputLinea = 0;
        this.processing = false;
        this.loadingFormatoPrecio = false;
        this.mode = '';
        this.DescProducto = 0;
        this.editingProduct = null; // Variable para rastrear el producto que se está editando
        this.log = this.clog.log('NOTA-VENTA-DETALLES');
    }
    getNombreBodegaSeleccionada() {
        try {
            const header = this.cabeceraComponent ? this.cabeceraComponent.getHeaderData() : null;
            const codigoBodega = header ? header.codigoBodega : null;
            const cabeceraAny = this.cabeceraComponent;
            const bodegas = cabeceraAny && cabeceraAny.optionsBodega ? cabeceraAny.optionsBodega : [];
            const bodega = bodegas && codigoBodega ? bodegas.find((b) => b.value === codigoBodega || b.codigo === codigoBodega) : null;
            return (bodega && (bodega.label || bodega.nombre)) ? (bodega.label || bodega.nombre) : (codigoBodega ? `${codigoBodega}` : '');
        }
        catch (_a) {
            return '';
        }
    }
    esErrorSaldoInsuficiente(mensaje) {
        const ctx = (mensaje && mensaje.contexto) ? String(mensaje.contexto) : '';
        const txt = (mensaje && mensaje.texto) ? String(mensaje.texto) : '';
        return ctx.includes('SaldoDisponible') || txt.toLowerCase().includes('cantidad disponible en bodega') || txt.toLowerCase().includes('saldo');
    }
    ngOnInit() {
        this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
        this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
        this.createForms();
        this.formChangesSubscriptions();
    }
    createForms() {
        this.formDetails = this.fb.group({
            codigoProducto: ['', [Validators.required]],
            formato: [null, [Validators.required]],
            cantidad: [null, [Validators.required, Validators.min(1)]],
            precioUnitario: [null, [Validators.required]],
            descuento: [null],
        });
    }
    resetFormDetails() {
        this.formDetails.reset();
        this.formDetails.markAsPristine();
        this.formDetails.markAsUntouched();
        this.formDetails.get('codigoProducto').setValue('');
        this.formDetails.get('formato').setValue(null);
        this.formDetails.get('cantidad').setValue(null);
        this.formDetails.get('precioUnitario').setValue(null);
        this.formDetails.get('descuento').setValue(null);
        this.modalSeleccionarProducto.clearLast();
        // Solo habilitar el formulario si el modo no es 'SHOW'
        if (this.mode !== 'SHOW') {
            this.formDetails.enable();
        }
        this.optionsFormato = [];
        this.productoSeleccionado = null;
    }
    formChangesSubscriptions() {
        // código de producto (trim extremos; validar cliente y unidad antes de consultar)
        this.formDetails
            .get('codigoProducto')
            .valueChanges.pipe(debounceTime(1000))
            .subscribe((codigo) => {
            const trimmed = codigo != null ? String(codigo).trim() : '';
            if (trimmed === '') {
                return;
            }
            if (trimmed !== codigo) {
                this.formDetails.get('codigoProducto').setValue(trimmed, { emitEvent: false });
            }
            if (!this.headerData || !this.headerData.cliente) {
                this.showMessageSeleccionCliente();
                return;
            }
            if (!this.validateUnidadNegocioCabecera()) {
                this.showMessageSeleccionUnidadNegocio();
                return;
            }
            this.modalSeleccionarProducto.searchBySKU(trimmed, false, true);
        });
        // formato
        this.formDetails.get('formato').valueChanges.subscribe((formato) => this.handleFormatoChange());
    }
    // Método consumido desde parent
    handleHeaderDataChange(headerData) {
        this.log('handleHeaderDataChange', headerData);
        this.headerData = headerData;
        this.getPrecioUnitario();
    }
    abrirModalSeleccionarProducto() {
        // this.modalSeleccionarProducto.show()
        //MOSTRAR MENSAJE DE CLIENTE FALTANTE
        if (!this.headerData.cliente) {
            this.showMessageSeleccionCliente();
            return;
        }
        //MOSTRAR MENSAJE DE UNIDAD DE NEGOCIO FALTANTE
        if (!this.validateUnidadNegocioCabecera()) {
            this.showMessageSeleccionUnidadNegocio();
            return;
        }
        const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
        this.modalSeleccionarProducto.showWithConfig({
            cleanData: true,
            showUnidadDeNegocioIfAllowed: true,
            showInforAdicionar: true,
            defaultUnidadNegocio: unidad_negocio_codigo,
        });
    }
    //MOSTRAR DETALLE ADD
    show() {
        this.mode = 'ADD';
        this.currentProcess = null;
    }
    //CARGAR DATOS DEL EDITAR NOTA VENTA
    Load(nv, mode) {
        this.mode = mode;
        if (this.mode === 'SHOW') {
            this.formDetails.disable();
        }
        else {
            this.formDetails.enable();
        }
        //SI EXISTE NOTA DE VENTA - MOSTRAR RESULTADO
        if (nv) {
            // Crear una copia profunda para evitar referencias compartidas
            this.currentProcess = {
                documentTotal: nv.DocumentTotal ? JSON.parse(JSON.stringify(nv.DocumentTotal)) : null,
                productDocument: nv.ProductDocument ? JSON.parse(JSON.stringify(nv.ProductDocument)) : null,
                proceso: nv.proceso,
                folio: nv.folio,
                cabecera: nv.cabecera ? JSON.parse(JSON.stringify(nv.cabecera)) : null,
            };
        }
    }
    getProducts({ inputParams: modalInputParams, callback }) {
        const self = this;
        const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
        this.log(modalInputParams);
        const inputParams = {
            empresa_rut: modalInputParams.empresa_rut,
            sku: modalInputParams.sku,
            descripcion: modalInputParams.descripcion,
            tipobusquedad_afecto_exento: modalInputParams.tipobusquedad_afecto_exento,
            familia: modalInputParams.familia,
            rubro: modalInputParams.rubro,
            unidad_negocio_codigo: unidad_negocio_codigo,
            paginaActual: modalInputParams.paginaActual,
            cantidadRegistrosPorPagina: modalInputParams.cantidadRegistrosPorPagina,
            sucursal_codigo: modalInputParams.sucursal_codigo,
        };
        this.productoService.obtenerSegunFiltroProductosFacturables(inputParams, ({ mensajes, respuesta }) => {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            if (!respuesta) {
                callback(new QueryResult(null, 0, 0, 0));
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
        });
    }
    getProductsByUnidadNegocio({ inputParams, callback }) {
        if (!inputParams.unidad_negocio_codigo) {
            const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
            inputParams.unidad_negocio_codigo = unidad_negocio_codigo;
        }
        this.modalSeleccionarProducto.getProductsByUnidadNegocio({ inputParams, callback });
    }
    onProductoSeleccionado({ data: _productoSeleccionado, origen, fromInlineSkuSearch }) {
        if (fromInlineSkuSearch && this.permiteUnidadNegocio) {
            const header = this.cabeceraComponent.getHeaderData();
            const unidadCabecera = header && !Array.isArray(header) && header.unidad_negocio_codigo != null && header.unidad_negocio_codigo !== ''
                ? String(header.unidad_negocio_codigo)
                : null;
            const unidadProducto = _productoSeleccionado.unidad_negocio_codigo != null && _productoSeleccionado.unidad_negocio_codigo !== ''
                ? String(_productoSeleccionado.unidad_negocio_codigo)
                : null;
            if (unidadCabecera !== unidadProducto) {
                this.toastService.error('El producto no pertenece a la unidad de negocio seleccionada.');
                this.onProductoNoEncontrado();
                return;
            }
        }
        const { rutCliente, direccion_codigo } = this.cabeceraComponent.getHeaderData();
        this.productoSeleccionado = _productoSeleccionado;
        this.formDetails.get('codigoProducto').setValue(_productoSeleccionado.sku);
        this.formatoProductoService.GetFormatosByCodigo(this.rutEmpresa, this.productoSeleccionado.codigo, ({ mensajes, respuesta }) => {
            this.optionsFormato = respuesta.registros.map((formato) => (Object.assign({ value: formato.formato_codigo, label: formato.formato_nombre }, formato)));
            this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('formato'), this.optionsFormato);
        });
        // funcion para obtener descuento especial
        this.obtenerDescuentoEspecialProductxCliente(_productoSeleccionado, rutCliente, direccion_codigo);
        // Solo habilitar el formulario si el modo no es 'SHOW'
        if (this.mode !== 'SHOW') {
            this.formDetails.enable();
        }
    }
    obtenerDescuentoEspecialProductxCliente(productoSeleccionado, rutCliente, direccion_codigo) {
        //Obtener descuento especial del producto si el producto correspondiente al cliente lo tiene.
        const inputParams = {
            entidad: {
                empresa_rut: this.rutEmpresa,
                sku: productoSeleccionado.sku.toString(),
                rut_cliente: Number(rutCliente),
                direccion_codigo: Number(direccion_codigo),
            },
        };
        this.formatoProductoService.ObtenerDescuentoEspecialProducto(inputParams, ({ mensajes, respuesta }) => {
            //*Si el producto tiene descuento especial el input Descuento se desactiva
            const resp = respuesta != null;
            if (resp) {
                this.DescProducto = respuesta.monto_descuento;
                this.formDetails.get('descuento').setValue(this.DescProducto.toString());
            }
            else {
                //*Si no se encuentra activo para el producto sin descuento especial
                this.DescProducto = 0;
                this.formDetails.get('descuento').setValue(this.DescProducto.toString());
            }
        });
    }
    onProductoNoEncontrado(payload) {
        // Importante: el modal dispara "onNotFound" con el código actual (que puede ser parcial
        // mientras el usuario sigue escribiendo). Antes se llamaba a resetFormDetails(), lo cual
        // limpiaba también codigoProducto y generaba la UX incómoda de "borrarse" el input.
        const codigoActual = this.formDetails.get('codigoProducto').value;
        if (payload && payload.esInactivo) {
            this.limpiarSeleccionProductoSinBorrarCodigo(codigoActual);
            return;
        }
        if (this.permiteUnidadNegocio && payload && payload.fromInlineSkuNotFound && payload.skuBuscado) {
            this.mostrarErrorSiSkuExisteEnOtraUnidadNegocio(String(payload.skuBuscado).trim(), () => this.limpiarSeleccionProductoSinBorrarCodigo(codigoActual));
            return;
        }
        this.limpiarSeleccionProductoSinBorrarCodigo(codigoActual);
    }
    /** Limpia formato/cantidad/precio/descuento y mantiene el código en el input. */
    limpiarSeleccionProductoSinBorrarCodigo(codigoActual) {
        this.formDetails.get('formato').setValue(null);
        this.formDetails.get('cantidad').setValue(null);
        this.formDetails.get('precioUnitario').setValue(null);
        this.formDetails.get('descuento').setValue(null);
        this.modalSeleccionarProducto.clearLast();
        this.optionsFormato = [];
        this.productoSeleccionado = null;
        this.DescProducto = 0;
        this.formDetails.get('codigoProducto').setValue(codigoActual, { emitEvent: false });
    }
    /**
     * Si el SKU no aparece en la búsqueda filtrada por unidad pero existe en otra unidad,
     * muestra el toast de error (caso típico: helados vs refrigerados).
     */
    mostrarErrorSiSkuExisteEnOtraUnidadNegocio(sku, luego) {
        if (!sku) {
            luego();
            return;
        }
        const inputParams = {
            empresa_rut: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            sku: sku,
            descripcion: '',
            tipobusqueda_estado: -1,
            tipobusquedad_afecto_exento: 0,
            familia: [],
            rubro: [],
            paginaActual: 1,
            cantidadRegistrosPorPagina: 10,
        };
        this.productoService.ObtenerSegunSku(inputParams, ({ mensajes, respuesta }) => {
            if (mensajes && mensajes.length > 0) {
                this.messageRendererService.showErrors(mensajes);
            }
            const header = this.cabeceraComponent.getHeaderData();
            const uCab = header && !Array.isArray(header) && header.unidad_negocio_codigo != null && header.unidad_negocio_codigo !== ''
                ? String(header.unidad_negocio_codigo)
                : null;
            const registros = respuesta && respuesta.registros ? respuesta.registros : [];
            const producto = registros.length ? registros.find((r) => String(r.sku) === String(sku)) || registros[0] : null;
            if (producto && uCab != null) {
                const uProd = producto.unidad_negocio_codigo != null && producto.unidad_negocio_codigo !== ''
                    ? String(producto.unidad_negocio_codigo)
                    : null;
                if (uProd != null && uCab !== uProd) {
                    this.toastService.error('El producto no pertenece a la unidad de negocio seleccionada.');
                }
            }
            luego();
        });
    }
    // limpiarDataProductoSeleccionado() {
    //   this.formDetails.get("productoExistente.cantidad").setValue(0)
    //   this.productoSeleccionado = null
    //   this.optionsFormato = []
    //   this.formDetails.get("formato").setValue(null)
    //   this.formDetails.get("precioUnitario").setValue(null)
    // }
    handleFormatoChange() {
        this.getPrecioUnitario();
    }
    getPrecioUnitario() {
        if (!this.headerData || !this.headerData.cliente || !this.productoSeleccionado || !this.formDetails.get('formato').value)
            return;
        this.loadingFormatoPrecio = true;
        this.log('getPrecioUnitario GO!');
        // Limpiar
        this.formDetails.get('precioUnitario').setValue(null);
        const formatoSeleccionado = this.formDetails.get('formato').value;
        const inputParams = {
            empresa_rut: this.rutEmpresa,
            producto_codigo: this.productoSeleccionado.codigo,
            formato_codigo: this.optionsFormato.filter((opt) => opt.value === formatoSeleccionado)[0].formato_codigo,
            lista_precio_codigo: this.headerData.cliente.lista_precio_codigo,
            tipo_producto_codigo: this.productoSeleccionado.tipo_producto_codigo,
        };
        this.productoService.GetPrecioUnitario(inputParams, ({ precio_unitario }) => {
            this.formDetails.get('precioUnitario').setValue(precio_unitario);
            this.loadingFormatoPrecio = false;
        });
    }
    getDetalleData() {
        if (!this.currentProcess)
            return null;
        this.log('getdetalleData', this.currentProcess.productDocument);
        return this.currentProcess;
    }
    agregarProducto() {
        const valido = this.formValidatorsService.validate(this.formDetails);
        this.processing = true;
        //* si existe DescEspecial al agregar producto el descuento lineal se mantiene en
        if (!valido) {
            this.processing = false;
            return;
        }
        const precioUnitario = this.formDetails.get('precioUnitario').value;
        if (precioUnitario === null || precioUnitario === undefined || Number(precioUnitario) === 0) {
            this.toastService.error('No está permitido agregar productos con precio 0.');
            this.processing = false;
            return;
        }
        if (this.formDetails.get('cantidad').value > 1 && this.formDetails.get('formato').value.includes('MED')) {
            this.toastService.error('La cantidad debe ser 1 cuando el formato es MED');
            this.processing = false;
            return;
        }
        // Validar que no agregue 2 veces
        if (this.currentProcess && this.currentProcess.productDocument) {
            const { codigoProducto, formato } = this.formDetails.value;
            const codigoLinea = String(codigoProducto != null ? codigoProducto : '').trim();
            const _listaSimilares = this.currentProcess.productDocument.filter((prod) => prod.codigo === codigoLinea && prod.formato === formato);
            if (_listaSimilares && _listaSimilares.length > 0) {
                this.toastService.error('Producto ya se encuentra agregado');
                this.processing = false;
                return;
            }
        }
        // Validar saldo real en la bodega seleccionada (misma fuente que el modal de stock).
        if (this.productoSeleccionado && this.cabeceraComponent) {
            const header = this.cabeceraComponent.getHeaderData();
            const codigoBodega = header ? header.codigoBodega : null;
            const formatoCodigo = this.formDetails.get('formato').value;
            const cantidadSolicitadaRaw = Number(this.formDetails.get('cantidad').value);
            const cantidadSolicitada = Number.isFinite(cantidadSolicitadaRaw) ? cantidadSolicitadaRaw : 0;
            const self = this;
            const inputParamsStock = {
                entidad: {
                    rut_empresa: Number(this.rutEmpresa),
                    sucursal_codigo: Number(this.sucursalEmpresa),
                    producto_codigo: this.productoSeleccionado.codigo,
                },
                paginaActual: 1,
                cantidadRegistrosPorPagina: -1,
            };
            this.saldoStockService.obtenerStockProducto(inputParamsStock, function ({ mensajes, respuesta }) {
                const ok = respuesta !== null;
                if (!ok) {
                    self.messageRendererService.showErrors(mensajes);
                    self.processing = false;
                    return;
                }
                const registros = respuesta && respuesta.registros ? respuesta.registros : [];
                const match = registros.find((r) => String(r.bodega_codigo) === String(codigoBodega) && String(r.formato_codigo) === String(formatoCodigo));
                const stockDisponibleRaw = match ? Number(match.stock_disponible) : 0;
                const stockDisponible = Number.isFinite(stockDisponibleRaw) ? stockDisponibleRaw : 0;
                const nombreBodega = match && match.bodega_nombre ? match.bodega_nombre : self.getNombreBodegaSeleccionada();
                const saldoInsuficiente = stockDisponible < cantidadSolicitada;
                if (saldoInsuficiente) {
                    // Solo alerta: se permite continuar con el proceso.
                    if (/(bodega)/i.test(nombreBodega)) {
                        self.toastService.warning(`El producto fue agregado, pero la ${nombreBodega} no cuenta con stock suficiente.`);
                    }
                    else {
                        self.toastService.warning(`El producto fue agregado, pero la bodega ${nombreBodega} no cuenta con stock suficiente.`);
                    }
                }
                const notaEsp = {};
                notaEsp.mode = self.mode;
                notaEsp.current = self.currentProcess;
                notaEsp.suppressSuccessToast = saldoInsuficiente === true;
                self.processing = false;
                self.onAddProductoRequest.emit(notaEsp);
            });
            return;
        }
        // if (!this.formDetails.valid) {
        //   this.toastrService.warning('Favor complete los datos requeridos');
        //   return
        // }
        // this.onAddProductoRequest.emit({
        //   codigo: this.formDetails.get("codigoProducto").value,
        //   formato: this.formDetails.get("formato").value,
        //   cantidad: Number(this.formDetails.get("cantidad").value),
        //   precio: Number(this.formDetails.get("precioUnitario").value),
        //   descuento: this.formDetails.get("descuento").value ? Number(this.formDetails.get("descuento").value) : 0
        // })
        const notaEsp = {};
        notaEsp.mode = this.mode;
        notaEsp.current = this.currentProcess;
        this.onAddProductoRequest.emit(notaEsp);
    }
    validate() {
        this.formValidatorsService.validateAllFormFields(this.formDetails);
        return this.formDetails.valid;
    }
    // Obtener la cantidad de productos agregados
    get cantidadProductos() {
        if (this.currentProcess && this.currentProcess.productDocument && Array.isArray(this.currentProcess.productDocument)) {
            return this.currentProcess.productDocument.length;
        }
        return 0;
    }
    createPayloadAddProducto() {
        //TRANSFORM DESCUENTO EN FORMATO "," POR "."
        let descproduct = '';
        const descuentoProduct = this.formDetails.get('descuento').value;
        if (descuentoProduct) {
            descproduct = descuentoProduct.replace(',', '.');
        }
        else {
            descproduct = '0';
        }
        const codigoProductoVal = this.formDetails.get('codigoProducto').value;
        return {
            codigo: String(codigoProductoVal != null ? codigoProductoVal : '').trim(),
            formato: this.formDetails.get('formato').value,
            cantidad: Number(this.formDetails.get('cantidad').value),
            precio: Number(this.formDetails.get('precioUnitario').value),
            descuento: this.formDetails.get('descuento').value ? Number(descproduct) : 0,
            descripcion_producto: this.productoSeleccionado.descripcion,
            unidad_negocio_codigo: this.productoSeleccionado.unidad_negocio_codigo,
            descuento_tope: 0,
            band_desc_esp: Number(this.DescProducto),
        };
    }
    //HABILITAR LA EDICION DE LOS INPUT
    EditarProducto(pedido) {
        this.onEditingProduct.emit(true);
        this.inputLinea = pedido.linea;
        this.editingProduct = pedido;
    }
    //FUNCION QUE PERMITE ACTUALIZAR EL PRODUCTO MANTENIENDO EL ORDEN Y RECALCULANDO TOTALES
    //UNA VEZ QUE PRESIONE EL CHECK
    // ACTUALIZAR LA CANTIDAD DEL PEDIDO
    ProcesoEditarPedidoCompletado(pedido) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const precio = pedido.precio !== null && pedido.precio !== undefined ? Number(pedido.precio) : 0;
            if (precio === 0) {
                this.toastService.error('No está permitido agregar productos con precio 0.');
                return;
            }
            this.inputLinea = 0;
            this.onEditingProduct.emit(false);
            try {
                //TRANSFORM DESCUENTO EN FORMATO "," POR "."
                let descproduct = '';
                const descuentoProduct = pedido.descuento.toString();
                if (descuentoProduct) {
                    descproduct = descuentoProduct.replace(',', '.');
                }
                else {
                    descproduct = '0';
                }
                // INTERNAMENTE ELIMINAR Y AGREGAR PEDIDO PARA RECALCULAR TOTALES
                const linea = pedido.linea;
                //ELIMINAR PRODUCTO DEL MISMO PROCESO GENERADO:
                let currentProcess = yield this.notaVentaService
                    .EliminarProductoDelEdit(this.currentProcess.proceso, this.currentProcess.folio, this.currentProcess.cabecera.tipoDocumentoDTE, linea)
                    .toPromise();
                //AGREGAR PRODUCTO DEL MISMO PROCESO GENERADO:
                const producto = {
                    codigo: pedido.codigo,
                    formato: pedido.formato,
                    cantidad: pedido.cantidad,
                    precio: pedido.precio,
                    descuento: Number(descproduct),
                    descripcion_producto: pedido.descripcion_producto,
                    unidad_negocio_codigo: this.currentProcess.cabecera.unidad_negocio_codigo,
                    descuento_tope: pedido.descuento_tope,
                    band_desc_esp: 0,
                };
                if (this.currentProcess && this.currentProcess.productDocument) {
                    const payload = {
                        cabecera: this.currentProcess.cabecera,
                        folio: this.currentProcess.folio,
                        proceso: this.currentProcess.proceso,
                        ProductDocument: [producto],
                    };
                    currentProcess = yield this.notaVentaService.AgregarProductoDeNotaEsp(payload).toPromise();
                }
                // Asegurar que currentProcess tenga el folio correcto
                if (currentProcess) {
                    currentProcess.folio = this.currentProcess.folio;
                }
                // ACTUALIZAR EL PROCESO ACTUAL CON LOS TOTALES RECALCULADOS
                this.currentProcess = currentProcess;
                this.editingProduct = null; // Restablecer la variable después de completar la edición
                this.onEditingProduct.emit(false);
                this.toastService.success('Producto editado exitosamente');
                this.log('Producto editado y totales recalculados:', currentProcess);
            }
            catch (error) {
                this.log('Error al editar producto:', error);
                this.toastService.error('Error al editar el producto');
                this.editingProduct = null;
            }
        });
    }
    fillProductos(currentProcess) {
        this.processing = false;
        this.currentProcess = currentProcess;
        this.resetFormDetails();
    }
    eliminarProducto(producto) {
        //CONFIRMACION PARA ELIMINAR PRODUCTO
        this.modalConfirm.showWithInlineConfig('Eliminar pedido', '¿Desea eliminar el pedido seleccionado?', () => {
            this.editingProduct = null; // Restablecer la variable después de completar la edición
            this.onDeleteProductoRequest.emit({ producto, current: this.currentProcess, mode: this.mode });
        });
    }
    clearContent() {
        this.resetFormDetails();
        this.currentProcess = null;
        this.totalesDocumento = null;
        this.headerData = null;
        this.productoSeleccionado = null;
        this.editingProduct = null;
        this.inputLinea = 0;
        this.DescProducto = 0;
        this.processing = false;
    }
    validateUnidadNegocioCabecera() {
        if (!this.permiteUnidadNegocio)
            return true;
        const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();
        return !!unidad_negocio_codigo;
    }
    showMessageSeleccionUnidadNegocio() {
        this.toastService.warning('Seleccione unidad de negocio');
    }
    showMessageSeleccionCliente() {
        this.toastService.warning('Seleccione Cliente');
    }
}
